
import React from 'react'

interface SocialCard {
  id: string
  title: string
  imageUrl: string
  platform: string
  description: string
  linkUrl: string
}

interface SocialCardModalProps {
  isOpen: boolean
  onClose: () => void
  socialCard: SocialCard | null
}

export const SocialCardModal: React.FC<SocialCardModalProps> = ({
  isOpen,
  onClose,
  socialCard
}) => {
  if (!isOpen || !socialCard) return null

  // 处理点击背景关闭弹窗
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white border-4 border-black max-w-2xl w-full mx-4 relative">
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 bg-black text-white hover:bg-white hover:text-black border-2 border-black flex items-center justify-center text-lg font-bold transition-none z-10"
        >
          ×
        </button>
        
        {/* 弹窗内容 - 保持不变 */}
        <div className="p-8">
          {/* 社交名片图片 */}
          <div className="w-full h-64 border-4 border-black mb-6 overflow-hidden">
            <img 
              src={socialCard.imageUrl} 
              alt={socialCard.title}
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* 社交名片信息 */}
          <div className="space-y-6">
            {/* 标题 */}
            <h3 className="text-3xl font-black">{socialCard.title}</h3>
            
            {/* 平台 */}
            <div className="flex items-center space-x-2">
              <span className="text-lg font-bold">平台：</span>
              <span className="text-lg">{socialCard.platform}</span>
            </div>
            
            {/* 描述 */}
            <div className="space-y-2">
              <div className="text-lg leading-relaxed">
                {socialCard.description}
              </div>
            </div>
            
            {/* 访问链接 */}
            <div className="pt-4">
              <a 
                href={socialCard.linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-black text-white px-6 py-3 text-lg font-bold hover:bg-white hover:text-black border-2 border-black transition-none inline-block"
              >
                访问
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
